import { render, staticRenderFns } from "./Tourwidget.vue?vue&type=template&id=31b3e9cf"
import script from "./Tourwidget.vue?vue&type=script&lang=js"
export * from "./Tourwidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports